import {
  getMobileAppAndroidPackage,
  getMobileAppIosAppStoreId,
  isValidEnvValue,
} from '@/config/env-config';

const ANDROID_PACKAGE_PLACEHOLDER = '__MOBILE_APP_ANDROID_PACKAGE__';
const ANDROID_PACKAGE_FALLBACK = 'com.newcore.auth.dev';
const IOS_APP_STORE_ID_PLACEHOLDER = '__MOBILE_APP_IOS_APP_STORE_ID__';
const IOS_APP_STORE_ID_FALLBACK = '6754811883';
const PLAY_STORE_BASE_URL = 'https://play.google.com/store/apps/details';
const PLAY_STORE_PACKAGE_PARAM = 'id';
const PLAY_STORE_REFERRER_PARAM = 'referrer';
const APP_STORE_BASE_URL = 'https://apps.apple.com/app';

export function getAndroidPackage() {
  const runtimePackage = getMobileAppAndroidPackage();

  if (isValidEnvValue(runtimePackage, ANDROID_PACKAGE_PLACEHOLDER)) {
    return runtimePackage;
  }

  return ANDROID_PACKAGE_FALLBACK;
}

export function getIosAppStoreId() {
  const runtimeId = getMobileAppIosAppStoreId();

  if (isValidEnvValue(runtimeId, IOS_APP_STORE_ID_PLACEHOLDER)) {
    return runtimeId;
  }

  return IOS_APP_STORE_ID_FALLBACK;
}

/**
 * Returns the iOS App Store ID only when the runtime env var was actually
 * injected (no dev fallback). Use this for surfaces where falling back to a
 * dev/stub ID could silently send production users to the wrong app — most
 * notably the Apple Smart App Banner meta tag, which iOS renders natively
 * with no user-visible affordance to detect a mismatched app-id.
 */
export function getInjectedIosAppStoreId(): string | null {
  const runtimeId = getMobileAppIosAppStoreId();

  return isValidEnvValue(runtimeId, IOS_APP_STORE_ID_PLACEHOLDER)
    ? runtimeId
    : null;
}

export function getPlayStoreUrl(referrer?: string) {
  const url = new URL(PLAY_STORE_BASE_URL);
  url.searchParams.set(PLAY_STORE_PACKAGE_PARAM, getAndroidPackage());

  if (referrer) {
    url.searchParams.set(PLAY_STORE_REFERRER_PARAM, referrer);
  }

  return url.toString();
}

export function getAppStoreUrl() {
  return `${APP_STORE_BASE_URL}/id${getIosAppStoreId()}`;
}
